import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './OrderFeedbackCard.css';

const REORDER_SCORE_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const IMPROVEMENT_OPTIONS = [
  { label: 'Food quality', value: 'food_quality' },
  { label: 'Portion size', value: 'portion_size' },
  { label: 'Delivery timing', value: 'delivery_timing' },
  { label: 'Packaging', value: 'packaging' },
  { label: 'Menu choice', value: 'menu_choice' },
  { label: 'Nothing', value: 'nothing' },
];

class OrderFeedbackCard extends Component {
  state = {
    reorderScore: null,
    overallScore: null,
    improvementTags: [],
    otherComments: '',
  };

  toggleImprovement = value => {
    this.setState(previousState => {
      if (value === 'nothing') {
        return { improvementTags: ['nothing'] };
      }
      const withoutNothing = previousState.improvementTags.filter(
        tag => tag !== 'nothing'
      );
      return withoutNothing.includes(value)
        ? { improvementTags: withoutNothing.filter(tag => tag !== value) }
        : { improvementTags: [...withoutNothing, value] };
    });
  };

  handleSubmit = () => {
    this.props.onSubmit({
      previousOrderId: this.props.feedback.previousOrderId,
      restaurantId: this.props.feedback.restaurantId,
      orderedItemsSnapshot: this.props.feedback.orderedItemsSnapshot,
      reorderScore: this.state.reorderScore,
      overallScore: this.state.overallScore,
      improvementTags: this.state.improvementTags,
      otherComments: this.state.otherComments.trim(),
    });
  };

  handleSkip = () => {
    this.props.onSkip({
      previousOrderId: this.props.feedback.previousOrderId,
      restaurantId: this.props.feedback.restaurantId,
      orderedItemsSnapshot: this.props.feedback.orderedItemsSnapshot,
    });
  };

  renderOption = (option, selected, onClick) => (
    <button
      type="button"
      key={option.value}
      className={`order-feedback-chip${selected ? ' is-selected' : ''}`}
      aria-pressed={selected}
      aria-label={option.label}
      onClick={() => onClick(option.value)}
    >
      {option.label}
    </button>
  );

  renderScoreOption = (score, fieldName) => (
    <button
      type="button"
      key={score}
      className={`order-feedback-chip order-feedback-score${
        this.state[fieldName] === score ? ' is-selected' : ''
      }`}
      aria-pressed={this.state[fieldName] === score}
      aria-label={`${score} out of 10`}
      onClick={() => this.setState({ [fieldName]: score })}
    >
      {score}
    </button>
  );

  render() {
    if (!this.props.feedback) {
      return null;
    }

    return (
      <section className="order-feedback-card" aria-label="Lunch feedback">
        <h2>Help us improve lunch in 10 seconds</h2>
        <p className="order-feedback-summary">
          Last order:{' '}
          <strong>{this.props.feedback.orderedItemsSnapshot}</strong>
          <span>
            From: <strong>{this.props.feedback.restaurantName}</strong>
          </span>
        </p>

        <fieldset className="order-feedback-question">
          <legend>How was it overall?</legend>
          <div className="order-feedback-scale-hint">
            1 = bad, 10 = great
          </div>
          <div className="order-feedback-options order-feedback-score-options">
            {REORDER_SCORE_OPTIONS.map(score =>
              this.renderScoreOption(score, 'overallScore')
            )}
          </div>
        </fieldset>

        <fieldset className="order-feedback-question">
          <legend>How likely are you to order this again?</legend>
          <div className="order-feedback-scale-hint">
            1 = not likely, 10 = definitely
          </div>
          <div className="order-feedback-options order-feedback-score-options">
            {REORDER_SCORE_OPTIONS.map(score =>
              this.renderScoreOption(score, 'reorderScore')
            )}
          </div>
        </fieldset>

        <fieldset className="order-feedback-question">
          <legend>What could be better?</legend>
          <div className="order-feedback-options">
            {IMPROVEMENT_OPTIONS.map(option =>
              this.renderOption(
                option,
                this.state.improvementTags.includes(option.value),
                this.toggleImprovement
              )
            )}
          </div>
        </fieldset>

        <label className="order-feedback-comments">
          <span>Other comments</span>
          <textarea
            value={this.state.otherComments}
            rows="2"
            maxLength="500"
            onChange={event =>
              this.setState({ otherComments: event.target.value })
            }
          />
        </label>

        <div className="order-feedback-actions">
          <button
            type="button"
            className="order-feedback-submit"
            onClick={this.handleSubmit}
          >
            Done
          </button>
          <button
            type="button"
            className="order-feedback-skip"
            onClick={this.handleSkip}
          >
            Skip
          </button>
        </div>
      </section>
    );
  }
}

OrderFeedbackCard.propTypes = {
  feedback: PropTypes.shape({
    previousOrderId: PropTypes.number.isRequired,
    restaurantId: PropTypes.number.isRequired,
    restaurantName: PropTypes.string.isRequired,
    orderedItemsSnapshot: PropTypes.string.isRequired,
  }),
  onSubmit: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
};

export default OrderFeedbackCard;



// WEBPACK FOOTER //
// ./src/containers/Menu/OrderFeedbackCard/OrderFeedbackCard.js